import React from "react";
import { Constants } from "../../CommonMethhods/Constants";

function MTFDetailsTable(props) {
  const { gridVal } = props;

  const showMTFData = (gridVal) => {
    return (
      gridVal &&
      gridVal.map((item, key) => (
        <tr key={key}>
          <td>{item.balDate || "-"}</td>
          <td>{item.runningBal || "-"}</td>
          <td>{item.intPer || "-"}</td>
          <td>{item.intAmount || "-"}</td>
          <td>{item.fundedValue || "-"}</td>
          <td>{item.marginReq || "-"}</td>
          <td>{item.totalMTFColl || "-"}</td>
          <td>{item.shortfall ?? "-"}</td>
        </tr>
      ))
    );
  };

  return (
    <div className="table-responsive scroll-table report-table-wrapper">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">{Constants.Bal_Date}</th>
            <th scope="col" className="text-center">
              {Constants.Running_Bal}
            </th>
            <th scope="col" className="text-center">
              {Constants.Int_Per}
            </th>
            <th scope="col" className="text-center">
              {Constants.Int_Amount}
            </th>
            <th scope="col">Funded Value</th>
            <th scope="col">Final Margin required</th>
            <th scope="col">Total MTF Collateral</th>
            <th scope="col">Shortfall</th>
          </tr>
        </thead>
        <tbody>{showMTFData(gridVal)}</tbody>
      </table>
    </div>
  );
}

export default MTFDetailsTable;
